import { Form } from 'antd';
import { useFormikContext } from 'formik';
import { useEffect } from 'react';
import { type RoleSpecsFragment } from '../../../api/fragments/RoleSpecs';
import { type FormValues } from './RoleAddUserDrawer';
import SearchUserWithTableFieldByRole from './SeachUserWithTableFieldByRole';

export type RoleAddUserFormProps = {
    role: RoleSpecsFragment;
    onSubmit: () => void;
    setIsFormValid: React.Dispatch<React.SetStateAction<boolean>>;
};

const RoleAddUserForm = ({ role, onSubmit, setIsFormValid }: RoleAddUserFormProps) => {
    const { isValid } = useFormikContext<FormValues>();

    useEffect(() => {
        setIsFormValid(isValid);
    }, [isValid, setIsFormValid]);

    return (
        <Form id="addUsers" layout="vertical" name="addUsers" onSubmitCapture={onSubmit}>
            <SearchUserWithTableFieldByRole debounceTimeout={800} name="users" role={role} />
        </Form>
    );
};
export default RoleAddUserForm;
